import { Route, Routes } from 'react-router-dom';

import ProgramControlledAccess from 'hb-react/frontoffice/apps/Mentoring/container/ProgramControlledAccess';
import { ApplyMenteeToMentorRelationship } from 'hb-react/frontoffice/apps/Mentoring/pages/ApplyMenteeToMentorRelationship';
import { ApplyToBeMentee } from 'hb-react/frontoffice/apps/Mentoring/pages/ApplyToBeMentee';
import { ApplyToBeMentor } from 'hb-react/frontoffice/apps/Mentoring/pages/ApplyToBeMentor';
import MentorsIndexControlledAccess from 'hb-react/frontoffice/apps/Mentoring/pages/MentorsIndex';
import { EvErrorBoundary } from 'hb-react/shared/components/ErrorBoundary';

interface MentoringAppProps {
  disabledAccess?: boolean;
}

const MentoringApp = ({ disabledAccess = false }: MentoringAppProps) => (
  <EvErrorBoundary
    context={{
      tags: {
        module: `FO|Mentoring`,
      },
    }}
  >
    <MentoringRouter disabledAccess={disabledAccess} />
  </EvErrorBoundary>
);

export const MentoringRouter = ({ disabledAccess }: MentoringAppProps) => (
  <Routes>
    <Route path=":id">
      <Route element={<ProgramControlledAccess />}>
        <Route
          path="mentors"
          element={
            <MentorsIndexControlledAccess disabledAccess={disabledAccess} />
          }
        />
        <Route path="apply">
          <Route
            path="mentor"
            element={<ApplyToBeMentor disabledAccess={disabledAccess} />}
          />
          <Route
            path="mentee"
            element={<ApplyToBeMentee disabledAccess={disabledAccess} />}
          />
          <Route path=":mentorId">
            <Route
              path="mentee"
              element={
                <ApplyMenteeToMentorRelationship
                  disabledAccess={disabledAccess}
                />
              }
            />
          </Route>
        </Route>
      </Route>
    </Route>
  </Routes>
);

export default MentoringApp;
